// src/config/ProductAndControl.js
import { HttpBindingReportService } from "../services/BindingReportService";
import { ProductControl } from "../controls/ProductControl";

/**
 * Builds the service + ProductControl in the main viewer's "Data & overlays" section:
 * a toggle button showing the summary and the drawer under it, in one box on its own
 * line above the dates.
 */
export function addProductControl(map, target) {
  const service = new HttpBindingReportService(process.env.BINDING_REPORTS_URL);
  const control = new ProductControl({ service });
  map.addControl(control);
  // Toggle and drawer in one box, above the dates row.
  const box = document.createElement("div");
  box.className = "sidebar-product";
  const row = target.querySelector(".sidebar-data-row");
  if (row) row.before(box);
  else target.appendChild(box);
  const toggle = document.createElement("button");
  toggle.type = "button";
  toggle.className = "sidebar-product-toggle";
  const sync = () => {
    toggle.textContent = control.get("summaryText");
    toggle.setAttribute("aria-expanded", String(control.element.open));
    box.classList.toggle("sidebar-product--open", control.element.open);
  };
  toggle.addEventListener("click", () => {
    control.element.open = !control.element.open;
  });
  control.element.addEventListener("toggle", sync);
  control.on("change:summaryText", sync);
  sync();
  box.append(toggle, control.element);
  return control;
}
